module.exports = __webpack_public_path__ + "img/pafm_borderless_white.6ba6238d.svg";